import { extendTheme } from "@chakra-ui/react";

const config = {
  initialColorMode: "dark",
  useSystemColorMode: false,
};
export const customTheme = extendTheme({
  fonts: {
    heading: `Cera Pro`,
    body: `Cera Pro`,
  },
  config,
  components: {
    Input: {
      variants: {
        primary: {
          field: {
            bgColor: "#fff",
            color: "#000",
            _placeholder: {
              color: "gray",
              padding: "5",
            },
          },
        },
        secondary: {
          field: {
            bgColor: "#8758D0",
          },
        },
      },
      defaultProps: {
        variant: "primary",
      },
    },
    Textarea: {
      variants: {
        primary: {
          bgColor: "#fff",
          color: "#000",
          _placeholder: {
            color: "gray",
          },
        },
        secondary: {
          bgColor: "#8758D0",
        },
      },
      defaultProps: {
        variant: "primary",
      },
    },
    Form: {
      variants: {
        floating: {
          container: {
            _focusWithin: {
              label: {
                transform: "scale(0.85) translateY(-24px)",
                color: "#000000",
                borderRadius: "5px",
              },
            },
            "input:not(:placeholder-shown) + label, .chakra-select__wrapper + label":
              {
                transform: "scale(0.85) translateY(-24px)",
                color: "#000000",
                borderRadius: "5px",
              },
            label: {
              color: "#C4C4C4",
              top: 0,
              left: 0,
              zIndex: 2,
              position: "absolute",
              backgroundColor: "white",
              pointerEvents: "none",
              mx: 3,
              px: 1,
              my: 2,
              transformOrigin: "left top",
            },
          },
        },
      },
    },
    Button: {
      variants: {
        primary: {
          border: "none",
          bgColor: "purpleColor",
          borderRadius: "10px",
          color: "#fff",
          fontWeight: "300",
          _hover: {
            bgColor: "orangeColor",
            border: "1px solid",
            transition: "all 0.4s ease-in-out",
            color: "#fff",
          },
          _focus: {
            bgColor: "orangeColor",
            border: "1px solid",
            color: "#fff",
          },
          _active: {
            bgColor: "orangeColor",
            border: "1px solid",
            color: "#fff",
          },
        },
        secondary: {
          bgColor: "orangeColor",
          size: "md",
          borderRadius: "10px",
          border: "1px solid",
          color: "#fff",
          fontWeight: "300",
          _hover: {
            bgColor: "purpleColor",
            color: "#fff",
            transition: "all 0.4s ease-in-out",
          },
          _focus: {
            bgColor: "purpleColor",
            color: "#fff",
          },
          _active: {
            bgColor: "purpleColor",
            color: "#fff",
          },
        },
      },
      defaultProps: {
        variant: "primary",
      },
    },
  },

  colors: {
    purpleColor: "#7B47CC",
    semiPurple: "#F1EBF9",
    gradient: "linear-gradient(90deg, #F1EBF9 15%, #FDF8E7 139.13%)",
    semiOrange: "#FDF8E7",
    orangeColor: "#F3C948",
    color: "#000",
  },
});
